<template>
  <div class="page">
    <div class="topbar">
      <div class="brand"><span class="star">✦</span><span class="brand-text">卡密查询</span></div><a
        href="javascript:void(0)" class="top-link">余额查询</a>
    </div>
    <div class="hero">
      <div class="hero-title">卡密信息查询</div>
    </div>
    <div class="container">
      <div class="card">
        <div class="form-row">
          <div class="field"><label class="label">卡号<span class="req">*</span></label><input type="text"
              placeholder="请输入卡号" v-model="cardNo" class="input"></div>
          <div class="field"><label class="label">密码<span class="req">*</span></label><input type="password"
              v-model="password" placeholder="请输入卡密" class="input"></div>
          <div class="field captcha-field"><label class="label">验证码<span class="req">*</span></label>
            <div class="captcha-wrap"><input type="text" placeholder="请输入验证码" v-model="yzm" autocomplete="off"
                class="input captcha-input"><img :src="captcha" alt="验证码" title="点击刷新" class="captcha-img"
                @click="refCaptcha"></div>
          </div><button class="btn" @click="checkCard">查询</button>
        </div>
      </div>
      <div class="panel">
        <div class="panel-hd">账户信息查询</div>
        <div class="divider"></div>
        <div class="table pc-table-div">
          <div class="tr th">
            <div class="td">卡名称</div>
            <div class="td">卡额度</div>
            <div class="td">卡状态</div>
            <div class="td">售卡时间</div>
          </div>
          <div class="tr">
            <div class="td">{{ checkInfo.product_name || '-' }}</div>
            <div class="td">{{ checkInfo.amt || '-' }}</div>
            <div class="td">{{ checkInfo.status || '-' }}</div>
            <div class="td">{{ checkInfo.created_at || '-' }}</div>
          </div>
        </div>
      </div>
      <div class="panel">
        <div class="panel-hd">账户交易查询</div>
        <div class="divider"></div>
        <div class="table pc-table-div">
          <div class="tr th">
            <div class="td">交易时间</div>
            <div class="td">交易金额</div>
            <div class="td">交易后余额</div>
            <div class="td">交易类型</div>
          </div>
            <div class="tr" v-for="(item,index ) in checkInfo.detail" v-bind:key="index">
              <div class="td">{{ item.use_time || '-' }}</div>
              <div class="td">{{ item.use_momey || '-' }}</div>
              <div class="td">{{ item.balance || '-' }}</div>
              <div class="td">{{ item.remark || '-' }}</div>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios';

export default {
  name: 'HelloWorld',
  data() {
    return {
      captcha: '',
      checkInfo: [],
      loading: false,
      yzm: '',
      uid: '',
      cardNo: '',
      password: ''
    }
  },
  methods: {
    refCaptcha() {
      this.yzm = ''
      this.loading = true;
      axios.get('https://fun.queryxin.com/api/captcha')
        .then(response => {
          this.captcha = response.data.image;
          this.uid = response.data.uniqid;
        })
        .catch(error => {
          console.error('Error fetching data:', error);
          //this.error = '数据加载失败';
        })
        .finally(() => {
          this.loading = false;
        });
    },
    checkCard() {
      if (!this.cardNo || !this.password || !this.yzm) {
        return alert('请填写完整');
      }
      this.checkInfo = []
      axios.post('https://fun.queryxin.com/api/query', {
        cardNo: this.cardNo,
        password: this.password,
        yzm: this.yzm,
        uid: this.uid
      }).then(response => {
        if (response.data.code == 410) {
          this.refCaptcha()
          return alert(response.data.msg);
        }
        if (response.data.code != 200) {
          return alert(response.data.msg);
        }
        this.checkInfo = response.data;
        //this.captcha = response.data.image;
        //this.uid = response.data.uniqid;
      })
        .catch(error => {
          console.error('Error fetching data:', error);
          //this.error = '数据加载失败';
          alert("数据加载失败")
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  mounted() {
    this.refCaptcha();
  }
}
</script>

<style type="text/css">
@charset "UTF-8";

.page {
  height: 100vh;
  /* 占满视口 */
  overflow-y: auto;
  /* 允许竖向滚动 */
  -webkit-overflow-scrolling: touch;
  background: #f3f6fb;
}

.container {
  max-width: calc(100% - 48px);
  margin: 18px auto 40px;
}

/* 顶部栏 */
.topbar {
  height: 64px;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 28px;
  border-bottom: 1px solid #e9eef5;
}

.brand {
  display: flex;
  align-items: center;
  gap: 8px;
}

.brand .star {
  color: #19b4a9;
  font-size: 18px;
  line-height: 1;
}

.brand .brand-text {
  color: #19b4a9;
  font-size: 20px;
  font-weight: 700;
  letter-spacing: 1px;
}

.top-link {
  color: #19b4a9;
  text-decoration: none;
  font-size: 14px;
  padding-bottom: 4px;
  border-bottom: 2px solid #19b4a9;
}

/* 主标题 */
.hero {
  background: linear-gradient(#f3f6fb, #eef3fb);
  padding: 24px 0 18px;
  text-align: center;
}

.hero .hero-title {
  font-size: 34px;
  font-weight: 800;
  color: #1b2b3a;
  letter-spacing: 2px;
}

/* 查询卡片 */
.card {
  background: #fff;
  border-radius: 10px;
  padding: 18px 22px;
  box-shadow: 0 10px 24px rgba(16, 24, 40, 0.06);
  border: 1px solid #eef2f7;
}

.form-row {
  display: flex;
  align-items: center;
  gap: 18px;
  flex-wrap: wrap;
  /* 小屏自动换行 */
}

.field {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 320px;
  flex: 1;
}

.field .label {
  width: 60px;
  text-align: right;
  color: #1f2d3d;
  font-size: 14px;
  font-weight: 600;
}

.field .label .req {
  color: #ff4d4f;
  margin-left: 4px;
}

.field .input {
  flex: 1;
  height: 40px;
  padding: 0 12px;
  border: 1px solid #dfe7f2;
  border-radius: 6px;
  outline: none;
  font-size: 14px;
  line-height: 40px;
  color: #1f2d3d;
  background: #fff;
}

.field .input::-moz-placeholder {
  color: #a3afbf;
}

.field .input::placeholder {
  color: #a3afbf;
}

.field .input:focus {
  border-color: #19b4a9;
  box-shadow: 0 0 0 3px rgba(25, 180, 169, 0.15);
}

/* 验证码区 */
.captcha-field {
  min-width: 360px;
  /* 比普通字段稍宽 */
}

.captcha-wrap {
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 1;
}

.captcha-input {
  min-width: 140px;
}

.captcha-img {
  width: 110px;
  height: 40px;
  border-radius: 6px;
  border: 1px solid #dfe7f2;
  background: #fff;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
}

.btn {
  height: 40px;
  min-width: 110px;
  padding: 0 18px;
  border: none;
  border-radius: 8px;
  background: #19b4a9;
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  white-space: nowrap;
}

.btn:active {
  transform: translateY(1px);
}

/* 面板（表格区） */
.panel {
  margin-top: 18px;
  background: #fff;
  border-radius: 10px;
  padding: 18px 22px 14px;
  box-shadow: 0 10px 24px rgba(16, 24, 40, 0.06);
  border: 1px solid #eef2f7;
}

.panel-hd {
  font-size: 16px;
  font-weight: 700;
  color: #1f2d3d;
  margin-bottom: 12px;
  text-align: left;
}

.divider {
  height: 1px;
  background: #eef2f7;
  margin: 10px 0 12px;
}

.table {
  width: 100%;
  border-radius: 8px;
}

.tr {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  align-items: center;
}

.th {
  background: #fafbfd;
  color: #5b6b7c;
  font-weight: 700;
  font-size: 13px;
}

.td {
  padding: 14px 12px;
  border-top: 1px solid #eef2f7;
  text-align: center;
  color: #000000;
  font-size: 13px;
}

.tr.th .td {
  border-top: none;
}

.tr.empty .td {
  color: #a3afbf;
}

/* 移动端适配 */
@media (max-width: 768px) {
  .topbar {
    height: 56px;
    padding: 0 14px;
  }

  .brand .brand-text {
    font-size: 18px;
  }

  .top-link {
    font-size: 13px;
  }

  .hero {
    padding: 18px 0 12px;
  }

  .hero .hero-title {
    font-size: 22px;
    letter-spacing: 1px;
  }

  .container {
    max-width: calc(100% - 24px);
    margin: 12px auto 28px;
  }

  .card,
  .panel {
    border-radius: 12px;
    padding: 14px 14px 12px;
  }

  .field {
    min-width: 100%;
  }

  .field .label {
    width: 52px;
    font-size: 13px;
  }

  .field .input {
    height: 42px;
    font-size: 14px;
  }

  .captcha-wrap {
    width: 100%;
  }

  .captcha-img {
    width: 120px;
    height: 42px;
  }

  .btn {
    width: 100%;
    height: 44px;
    border-radius: 10px;
  }

  .table {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  .pc-table-div .tr {
    min-width: 640px;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    align-items: center;
  }

  .app-table-div .tr {
    min-width: 100%;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    align-items: center;
  }

  .td {
    padding: 12px 10px;
    font-size: 12px;
  }
}

@media (max-width: 420px) {
  .brand .brand-text {
    font-size: 16px;
  }

  .top-link {
    padding-bottom: 2px;
  }
}
</style>
